export const Size = {
  large: '1280px',
  medium: '1180px',
  container: '1224px',
  xss: '960px',
  small: '768px',
  xs: '376px'
}
